import React from 'react'
import CooperationRequestForm from '../../Components/Forms/CooperationRequestForms/CooperationRequestForm'
import Style from './CooperationRequest.module.css'

const CooperationRequest = () => {
  return (
    <div className={Style.PageHolder}>
      <div className={Style.rippleBackground}>
        <div className={`${Style.circle} ${Style.xxlarge} ${Style.shade1}`}></div>
        <div class={`${Style.circle} ${Style.xlarge} ${Style.shade2}`}></div>
        <div class={`${Style.circle} ${Style.large} ${Style.shade3}`}></div>
        <div class={`${Style.circle} ${Style.medium} ${Style.shade4}`}></div>
        <div class={`${Style.circle} ${Style.small} ${Style.shade5}`}></div>
      </div>


        <CooperationRequestForm/>
        
    </div>
  )
}

export default CooperationRequest